import { render, staticRenderFns } from "./ReMarkdown.vue?vue&type=template&id=0ec8fd0b&scoped=true"
import script from "./ReMarkdown.vue?vue&type=script&lang=js"
export * from "./ReMarkdown.vue?vue&type=script&lang=js"
import style0 from "./ReMarkdown.vue?vue&type=style&index=0&id=0ec8fd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8fd0b",
  null
  
)

export default component.exports